// True with a mouse or trackpad. Dialog fields take focus on open only then: on a
// touch screen, focusing a field raises the keyboard over the dialog it belongs to.
export const finePointer =
  typeof window === 'undefined' ? true : window.matchMedia('(pointer: fine)').matches
